import { fromJS } from 'immutable';
import {
    BRANCHES_GET_FAILED,
    BRANCHES_GET,
    BRANCHES_GET_SUCCESS
} from '../actions/branches';

const initialState = fromJS({
    isFetching: false,
    isFailed: false,
    data: []
});

const branches = (state = initialState, action) => {
    switch(action.type) {
        case BRANCHES_GET:
            return state.merge(
                {
                    isFetching: true
                }
            );

        case BRANCHES_GET_SUCCESS:
            return state.merge(
                {
                    isFetching: false,
                    data: action.branches
                }
            );

        case BRANCHES_GET_FAILED:
            return state.merge(
                {
                    isFetching: false,
                    isFailed: true
                }
            );

        default:
            return state;
    }
};

export default branches;


/** WEBPACK FOOTER **
 ** ./src/reducers/branches.js
 **/